<template>
  <div
    class="form-address"
  >
    <div class="form-address__text">
      <slot name="text" />
    </div>
    <div class="calculator__item calculator__item_address calculator__item_active">
      <ul class="calculator-form__fields">
        <li
          class="calculator-form__field calculator-form__field_input calculator-form__field_full-width calculator-form__field_street"
        >
          <span
            class="field-input"
            :class="{
              'field-item__error': $v.addressStreet.$error,
              'field-full': addressStreet.length
            }"
          >
            <label>
              <span class="label-description">Улица</span>
              <input
                ref="street"
                class="field-input__inner"
                placeholder="Улица"
                required
                type="text"
                autocomplete="new-password"
                data-type="to"
                :value="addressStreet"
              >

            </label>
            <span
              v-if="!$v.addressStreet.required"
              class="field__error"
            >
              Обязательно для заполнения
            </span>

            <span
              v-if="$v && $v.addressStreet.$error && !addressStreet.length"
              class="field__error_inv"
            >
              Обязательно для заполнения
            </span>

          </span>
        </li>
        <li
          class="calculator-form__field calculator-form__field_input calculator-form__field_full-width calculator-form__field_house"
        >
          <span
            class="field-input"
            :class="{
              'field-item__error': $v.addressHome.$error,
              'field-full': addressHome.length,
            }"
          >
            <label>
              <span class="label-description">Дом</span>
              <input
                ref="recipientHome"
                class="field-input__inner"
                placeholder="Дом"
                required
                type="text"
                autocomplete="new-password"
                :value="addressHome"
              >
            </label>
            <span
              v-if="!$v.addressHome.required"
              class="field__error"
            >
              Введите номер дома
            </span>
            <span
              v-if="$v && $v.addressHome.$error && !addressHome.length"
              class="field__error_inv"
            >
              Введите номер дома
            </span>
          </span>
        </li>
        <li
          class="calculator-form__field calculator-form__field_input calculator-form__field_full-width calculator-form__field_zip"
        >
          <span
            class="field-input"
          >
            <label>
              <span class="label-description">Индекс</span>
              <input
                ref="addressZip"
                :value="addressZip"
                class="field-input__inner"
                placeholder="Индекс"
                required
                :disabled="!showZipError"
                type="text"
                autocomplete="new-password"
                @input="onAddressZipChange"
              >
            </label>
          </span>
        </li>
      </ul>
    </div>
    <CalcComment
      v-if="!showZipError && addressZip"
      class="mt-3"
    >
      Индекс определен автоматически, проверьте его правильность
    </CalcComment>
    <div
      v-if="showZipError"
      class="form-address__error"
    >
      Мы не смогли найти автоматически индекс. Пожалуйста, введите его вручную
    </div>
  </div>
</template>

<script>
/* global $ */
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import {
  required,
} from 'vuelidate/lib/validators';
import { dadataApi } from '../../helpers/url';
import CalcComment from './components/CalcComment.vue';

Vue.use(Vuelidate);

export default {
  name: 'CalculatorFormAddressItem',
  components: {CalcComment},
  props: {
    addressStreet: {
      type: String,
      default: '',
    },
    addressHome: {
      type: String,
      default: '',
    },
    addressZip: {
      type: String,
      default: '',
    },
    cityName: {
      type: String,
      required: true,
    },
    addressDefault: {
      type: Object,
      default: () => ({}),
    },
    addressAll: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    showZipError: false,
    onRenderZip: true,
  }),
  watch: {
    addressDefault(val) {
      if (val) {
        this.initDadata();
      }
    },
    addressStreet(val) {
      if (!val) {
        this.initDadata();
        this.$emit('forceSubmit');
      }
    },
  },
  mounted() {
    this.initDadata();
  },

  methods: {
    initDadata() {
      if (!this.addressDefault.addressStreet || this.addressStreet) {
        this.initDadataFields();
        return;
      }
      this.initDefaultAddress();
    },
    initDefaultAddress() {
      if (!this.addressDefault.addressStreet || this.addressStreet) return;

      this.$emit('addressStreetChanged', this.addressDefault.addressStreet || '');
      this.$emit('addressHomeChanged', this.addressDefault.addressHome || '');
      this.$emit('addressZipChanged', this.addressDefault.addressZip || '');
      this.$emit('addressAllChanged', this.addressDefault.addressAll || '');

      this.$nextTick(this.initDadataFields);
    },
    initDadataFields() {
      if (this.$refs.street) {
        const self = this;
        const type = 'ADDRESS';
        const $street = $(this.$refs.street);
        const $home = $(this.$refs.recipientHome);

        const suggestionsStreet = $street
          .suggestions({
            serviceUrl: dadataApi,
            type,
            bounds: 'settlement-street',
            geoLocation: false,
            constraints: {
              label: '',
              locations: {
                city: this.cityName,
              },
            },
            scrollOnFocus: false,
            onSelect: (suggestion) => {
              self.$emit('addressHomeChanged', '');
              $(self.$refs.recipientHome).val('');
              self.$emit('addressStreetChanged', suggestion.value);
              self.addressSelectedPIP(suggestion, '');
              this.showZipError = false;
            },
            onSelectNothing() {
              self.$emit('addressHomeChanged', '');
              self.$emit('addressStreetChanged', '');
              self.$emit('addressZipChanged', '');
              this.showZipError = false;
              self.$v.addressStreet.$touch();
            },
          }).suggestions();
        $street.attr('autocomplete', 'new-password');
        suggestionsStreet.fixData();

        const suggestionsHome = $home
          .suggestions({
            serviceUrl: dadataApi,
            type: 'ADDRESS',
            hint: false,
            noSuggestionsHint: false,
            bounds: 'house',
            constraints: $street,
            scrollOnFocus: false,
            onSelect: (suggestion) => {
              self.$emit('addressHomeChanged', suggestion.value);
              if (suggestion.data.postal_code) {
                self.addressSelectedPIP(suggestion, suggestion.data.postal_code);
                this.showZipError = false;
              } else if (this.onRenderZip && this.addressDefault.addressZip) {
                self.addressSelectedPIP(suggestion, this.addressDefault.addressZip);
              } else {
                self.addressSelectedPIP(suggestion, '');
                this.showZipError = true;
              }
              this.onRenderZip = false;
            },
            onSelectNothing() {
              self.$emit('addressHomeChanged', '');
              self.$emit('addressZipChanged', '');
              self.$v.addressHome.$touch();
              this.showZipError = false;
            },
          }).suggestions();
        $home.attr('autocomplete', 'new-password');
        suggestionsHome.fixData();
      }
    },
    addressSelectedPIP(suggestion, zip) {
      this.$emit('addressZipChanged', zip);
      this.$emit('addressAllChanged', suggestion.unrestricted_value);
    },
    onAddressZipChange($event) {
      this.$emit('addressZipChanged', $event.target.value);
    },
  },
  validations: {
    addressStreet: {
      required,
    },
    addressHome: {
      required,
    },
  },
};
</script>
